"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var query_params_1 = __importDefault(require("@shared/constants/query-params"));
var angular = __importStar(require("angular"));
var EditableWidgetIsEnabled = /** @class */ (function () {
    function EditableWidgetIsEnabled($routeParams) {
        this.$routeParams = $routeParams;
    }
    EditableWidgetIsEnabled.prototype.isEnabled = function (widgetScope) {
        var _a;
        if (widgetScope === void 0) { widgetScope = {}; }
        return this.$routeParams[query_params_1.default.EDITABLE_WIDGETS] === 'true' &&
            !!((_a = widgetScope === null || widgetScope === void 0 ? void 0 : widgetScope.isEditablePptxEnabled) === null || _a === void 0 ? void 0 : _a.call(widgetScope));
    };
    EditableWidgetIsEnabled.$inject = [
        '$routeParams'
    ];
    return EditableWidgetIsEnabled;
}());
(function (angularModule) {
    angularModule.service('prPptxEditableWidgetIsEnabled', EditableWidgetIsEnabled);
})(angular.module('qualtrics.pr'));
